<template>
  <b-overlay :show="loading" opacity="0.99">
    <form v-on:submit="update" method="post">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <LabelRequiredField label="Nome" />
          <input
            :disabled="!permission('edit', 'service_charge_type')"
            type="text"
            ref="autofocus"
            v-model="name"
            class="form-control"
          />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <h6 class="mb-0 worksansr">
            Criação:
            {{ formatDate(item.created_at) }}
          </h6>
          <h6 class="mb-0 worksansr">
            Última alteração:
            {{ formatDate(item.updated_at) }}
          </h6>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <WarningMessage
            v-if="!permission('edit', 'service_charge_type')"
            message="Você não tem permissão para modificar tipos de cobrança de serviço"
          />
          <WarningRequiredFields
            v-if="permission('edit', 'service_charge_type')"
          />
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-12 text-left">
          <confirmation-dialog
            v-if="permission('remove', 'service_charge_type')"
            :disabled="loading"
            message-title="Confirmar"
            message-body="Deseja realmente apagar a tipo de cobrança? Só pode apagar caso não exista vinculo da tipo de cobrança com serviço!"
            open-text="EXCLUIR"
            open-class="btn-delete mr-2"
            open-left-icon="fa-trash mr-2"
            @yes="handleDelete"
          />
        </div>
        <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12 text-right">
          <v-btn
            v-if="permission('edit', 'service_charge_type')"
            :disabled="loading"
            type="submit"
            class="btn-save m-1"
          >
            <i class="fas fa-save mr-2 text-twenty"></i>
            {{ loading ? "Carregando" : "SALVAR" }}
          </v-btn>
        </div>
      </div>
    </form>
  </b-overlay>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";
import WarningMessage from "../Components/WarningMessage";
import LabelRequiredField from "../Components/LabelRequiredField";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import ConfirmationDialog from "../Components/ConfirmationDialog";

import permission from "../../lib/permission";

import { formatDate } from "../../lib/format";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

export default {
  name: "Edit",

  components: {
    ErrorsMessages,
    WarningMessage,
    WarningRequiredFields,
    LabelRequiredField,
    ConfirmationDialog,
  },

  props: {
    item: { type: Object },
  },

  data() {
    return {
      id: "",
      name: "",
      loading: false,
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    formatDate,

    async retrieve() {
      this.errors = [];
      this.id = this.item.id;
      this.name = this.item.name;
    },

    async update(event) {
      try {
        event.preventDefault();

        this.loading = true;

        const { user_id, id, rest_home_id, name } = this;

        let params = { user_id, id, rest_home_id, name };

        const response = await api.put(
          "/rest-home/service-charge-type/update",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$bvModal.hide(`edit_${String(id)}`);
          this.$emit("success");
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async handleDelete() {
      try {
        const { id } = this;

        let data = { id };

        const response = await api.delete(
          "/rest-home/service-charge-type/delete",
          {
            data,
          }
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>